export default __webpack_public_path__ + "static/media/50_mobile.7361c716.jpg";